import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconeDirective } from '../../../../directives/icone.directive';
import { OpcaoMenuFlutuante } from './menu-flutuante.types';

@Component({
    selector: 'app-menu-flutuante',
    imports: [RouterLink, IconeDirective],
    templateUrl: './menu-flutuante.component.html',
    styleUrl: './menu-flutuante.component.scss',
})
export class MenuFlutuanteComponent {
    public readonly opcoes = input.required<OpcaoMenuFlutuante[]>();
}
